/**
 * Home 2024 Series Carousel
 *
 * @author BarrelNY
 * @since 35.0.0
 */

import Flickity from '@lib/flickity-fade-ios15-patch'
import throttle from "@modules/main/throttle/throttle"

class SeriesCarousel {
  constructor(el) {
    this.el = el
    this.slides = el.querySelector('[data-slides]')
    this.background = el.querySelector('[data-background]')
    
    this.initCarousel()
  }
  initCarousel() {
    return new Flickity(this.slides, {
      cellAlign: 'center',
      prevNextButtons: false,
      autoPlay: true,
      pageDots: true,
      draggable: true,
      wrapAround: true,
      fade: true,
      contain: true,
      on: {
        change: i => {
          const slides = this.background.querySelectorAll('.image-2021')

          slides.forEach(slide => slide.classList.add('slide-faded'))
          const activeSlide = slides[i]
          if (activeSlide) {
            activeSlide.classList.remove('slide-faded')
          }
        }
      }
    })
  }
}

export default el => new SeriesCarousel(el)

